<div class="teams" *ngIf="hasStarted()">
  <app-players-list
    class="left"
    [team]="teams.home || {}"
    [typeTeam]="'home'"
    [selected]="playersSelected[0]"
    [disabled]="mapMode === 'zoneLeader' || live"
    [live]="live"
    [stats]="stats"
    (playerSelected)="onPlayerSelected($event, 0)">
  </app-players-list>
  <div class="wrapper-clearPlayerSelected">
    <div
      class="clearPlayerSelected" 
      [class.shown]="checkPlayerSelected()" 
      (click)="clearPlayerSelected()">
    </div>
    <span
      class="name"
      *ngIf="checkPlayerSelected()">
      {{ getNameCurrentPlaterSelected() }}
    </span>    
  </div>
  <app-players-list
    class="right"
    [team]="teams.visitor || {}"
    [typeTeam]="'visitor'"
    [selected]="playersSelected[1]"
    [disabled]="mapMode === 'zoneLeader' || live"
    [live]="live"
    [stats]="stats"
    (playerSelected)="onPlayerSelected($event, 1)">
  </app-players-list>
</div>
<div class="mapWrapper">
  <app-map-zone 
    *ngIf="mapMode === 'zone' || mapMode === 'zoneLeader'" 
    [teams]="teams" 
    [events]="events" 
    [mode]="mapMode"
    [playersSelected]="playersSelected">
  </app-map-zone>
  <app-map-grid
    *ngIf="mapMode === 'grid'" 
    [teams]="teams" 
    [playersIndex]="playersIndex"
    [events]="events" 
    [playersSelected]="playersSelected">
  </app-map-grid>
  <app-map-raw 
    *ngIf="mapMode === 'raw'" 
    [teams]="teams" 
    [events]="events"
    [playersSelected]="playersSelected">
  </app-map-raw>
  <div class="mobileTeamLabel home">
    <label>{{teams.home && teams.home.name}}</label>
    <!-- <div class="icon" inlineSVG="/assets/img/icons/ic_team.svg"></div> -->
  </div>
  <div class="mobileTeamLabel visitor">
    <label>{{teams.visitor && teams.visitor.name}}</label>
    <!-- <div class="icon" inlineSVG="/assets/img/icons/ic_team.svg"></div> -->
  </div>
</div>
<div class="mapFooter">
  <app-map-controls
    *ngIf="!live"
    [teams]="teams"
    [events]="events"
    [live]="live"
    (changeQuarter)="onQuarterChange($event)"
    (changeMapMode)="onMapModeChange($event)">
  </app-map-controls>
  <button class="legendToggle" (click)="showLegend = !showLegend" (blur)="showLegend = false">
    {{'Legend' | translate}}
  </button>
  <div class="legendWrapper" [class.open]="showLegend" *ngIf="mapMode === 'zone'">
    <app-legend
      title="{{ 'Points / Zone' | translate }}"
      type="enum"
      [legend]="[{icon: '/assets/img/icons/legend/number.svg'}]">
    </app-legend>
    <app-legend
      title="{{ 'Accuracy %' | translate }}"
      type="ramp"
      [legend]="[{icon: '/assets/img/icons/legend/accuracy-color.svg'}]"
      [domain]="{ min: ('Less' | translate), max: ('More' | translate) }">
    </app-legend>
  </div>
  <div class="legendWrapper" [class.open]="showLegend" *ngIf="mapMode === 'zoneLeader'">
    <app-legend
      title="{{ 'Points leader / zone' | translate }}"
      type="enum"
      [legend]="[{icon: '/assets/img/icons/legend/leader.svg'}]">
    </app-legend>
  </div>
  <div class="legendWrapper small-legend" [class.open]="showLegend" *ngIf="mapMode === 'grid'">
    <app-legend
      title="{{ 'Shots' | translate }}"
      type="ramp"
      [legend]="[{icon: '/assets/img/icons/legend/grid.svg'}]"
      [domain]="{ min: ('Less' | translate), max: ('More' | translate) }">
    </app-legend>
    <app-legend
      title="{{ 'Accuracy %' | translate }}"
      type="ramp"
      [legend]="[{icon: '/assets/img/icons/legend/accuracy-color.svg'}]"
      [domain]="{ min: ('Less' | translate), max: ('More' | translate) }">
    </app-legend>
  </div>
  <div class="legendWrapper small-legend" [class.open]="showLegend" *ngIf="mapMode === 'raw'">
    <app-legend
      title="{{ 'Shots' | translate }}"
      type="ramp"
      [legend]="[{icon: '/assets/img/icons/legend/shots.svg'}]"
      [domain]="{ min: ('Missed' | translate), max: ('Made' | translate) }">
    </app-legend>
  </div>
</div>